import * as React from 'react';

/** New pages start at the top; search-param changes (drawers, filters) keep their place. */
export function useResetScrollOnPathChange(pathname: string): void {
  // biome-ignore lint/correctness/useExhaustiveDependencies: pathname is the trigger, not a value the effect reads.
  React.useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
}
